import { render } from "./Index.vue?vue&type=template&id=4d7df68c&bindings={\"classrooms\":\"props\",\"searchQuery\":\"props\",\"flash\":\"props\",\"selectedRecord\":\"data\",\"search\":\"options\",\"showDeleteConfirmationModal\":\"options\",\"deleteRecord\":\"options\",\"navigateToEdit\":\"options\",\"toggleActions\":\"options\"}"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "4d7df68c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d7df68c')) {
    api.reload('4d7df68c', script)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=4d7df68c&bindings={\"classrooms\":\"props\",\"searchQuery\":\"props\",\"flash\":\"props\",\"selectedRecord\":\"data\",\"search\":\"options\",\"showDeleteConfirmationModal\":\"options\",\"deleteRecord\":\"options\",\"navigateToEdit\":\"options\",\"toggleActions\":\"options\"}", () => {
    api.rerender('4d7df68c', render)
  })

}

script.__file = "resources/js/Pages/Classrooms/Index.vue"

export default script